import { useState } from "react";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

/**
 * A-020 P4: Stift neben „Bauvorhaben:“ im Beleg (Angebot, AB, Rechnung).
 * Kleines Fenster mit Projekttitel und Baustelle; gespeichert wird im PROJEKT (eine Quelle), danach lädt der Beleg neu.
 */
const BauvorhabenStift = ({ projekt, onGespeichert }) => {
  const [offen, setOffen] = useState(false);
  const [titel, setTitel] = useState("");
  const [baustelle, setBaustelle] = useState("");
  const [laeuft, setLaeuft] = useState(false);
  if (!projekt?.id) return null;
  const oeffnen = () => { setTitel(projekt.titel || ""); setBaustelle(projekt.adresse || ""); setOffen(true); };
  const speichern = async () => {
    if (!titel.trim()) { toast.error("Bitte einen Projekttitel eintragen."); return; }
    setLaeuft(true);
    try {
      await api.put(`/module-projekte/${projekt.id}`, { titel: titel.trim(), adresse: baustelle.trim() });
      toast.success("Bauvorhaben geändert (im Projekt gespeichert)");
      setOffen(false);
      onGespeichert?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Speichern hat nicht geklappt.");
    } finally { setLaeuft(false); }
  };
  const feld = "h-10 w-full rounded-sm border border-input bg-background px-2 text-sm";
  return (
    <>
      <button type="button" onClick={oeffnen} title="Bauvorhaben ändern" aria-label="Bauvorhaben ändern"
        className="ml-2 inline-flex items-center justify-center w-8 h-8 rounded hover:bg-slate-200 text-slate-500 align-middle" data-testid="beleg-bauvorhaben-stift">
        <Pencil className="w-4 h-4" />
      </button>
      <Dialog open={offen} onOpenChange={setOffen}>
        <DialogContent className="max-w-md" data-testid="bauvorhaben-fenster">
          <DialogHeader><DialogTitle>Bauvorhaben ändern</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div>
              <label className="text-xs font-medium text-muted-foreground block mb-1">Projekttitel</label>
              <input value={titel} onChange={(e) => setTitel(e.target.value)} className={feld} data-testid="bauvorhaben-titel" />
            </div>
            <div>
              <label className="text-xs font-medium text-muted-foreground block mb-1">Baustelle (Adresse)</label>
              <input value={baustelle} onChange={(e) => setBaustelle(e.target.value)} className={feld} data-testid="bauvorhaben-baustelle" />
              <p className="text-xs text-muted-foreground mt-1">Leer lassen = Adresse des Kunden. Gespeichert wird im Projekt, es gilt dann überall.</p>
            </div>
          </div>
          <DialogFooter>
            <button type="button" onClick={() => setOffen(false)} className="px-3 h-10 rounded-sm border text-sm">Abbrechen</button>
            <button type="button" onClick={speichern} disabled={laeuft} className="px-4 h-10 rounded-sm bg-primary text-primary-foreground text-sm font-medium" data-testid="bauvorhaben-speichern">Speichern</button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BauvorhabenStift;
